import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Bell } from "lucide-react";
import DashboardLayout from "@/components/DashboardLayout";

const Notifications = () => {
  return (
    <DashboardLayout title="Notifications">
      <div className="max-w-4xl mx-auto">
        <Card className="shadow-lg hover:shadow-xl transition-shadow duration-300">
          <CardHeader className="border-b">
            <CardTitle className="text-xl flex items-center gap-2">
              <Bell className="w-5 h-5 text-muted-foreground" />
              No New Notifications
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="flex flex-col items-center justify-center py-8 text-center">
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <Bell className="w-8 h-8 text-primary" />
              </div>
              <p className="text-lg text-muted-foreground mb-2">
                You're all caught up!
              </p>
              <p className="text-sm text-muted-foreground">
                No new notifications at this time. We'll notify you when there's
                something new.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Notifications;
